<div class="validation-modal-header">
  <div class="header-info">
    <h4>Vehículos Disponibles</h4>
    <p style="color: var(--gl-text-secondary);">
      Selecciona haciendo clic sobre las unidades
    </p>
  </div>
</div>


<!-- Panel de Filtros Jerárquicos -->
<div class="filter-panel-card">
  <div class="row g-2">
    <div class="col-md-4 m-0">
      <label class="text-form-label mb-1">Operación</label>
      <p-dropdown [options]="operationsFilter" [(ngModel)]="selectedOperation" optionLabel="name" [showClear]="true"
        placeholder="Todas" [style]="{width: '100%'}">
      </p-dropdown>
    </div>
    <div class="col-md-4 m-0">
      <label class="text-form-label mb-1">Grupo</label>
      <p-dropdown [options]="filteredGroups" [(ngModel)]="selectedGroup" optionLabel="name" [showClear]="true"
        placeholder="Todos" [style]="{width: '100%'}">
      </p-dropdown>
    </div>
    <div class="col-md-4 m-0">
      <label class="text-form-label mb-1">Convoy</label>
      <p-dropdown [options]="filteredConvoys" [(ngModel)]="selectedConvoy" optionLabel="name" [showClear]="true"
        placeholder="Todos" [style]="{width: '100%'}">
      </p-dropdown>
    </div>
  </div>

  <div class="mt-2">
    <label class="text-form-label mb-1">Buscar Placa o Código</label>
    <div class="search-container-clean shadow-sm d-flex flex-row">
      <i class="material-icons search-icon-clean">search</i>
      <input class="text-input-clean" type="text" [(ngModel)]="vehicleSearchQuery" placeholder="Ej. ABC-123 o UNID-01">
      <button *ngIf="vehicleSearchQuery || selectedOperation || selectedGroup || selectedConvoy"
        class="btn btn-outline-secondary border-0 py-0 px-2 ms-2" type="button" (click)="clearFilters()">
        <i class="material-icons align-middle" style="font-size: 14px;">clear</i>
      </button>
    </div>
  </div>
</div>

<!-- Botones de Acción Masiva (Seleccionar/Deseleccionar todos) -->
<div class="d-flex justify-content-between mb-2 mt-3 px-1">
  <button type="button" class="btn btn-outline-primary btn-sm py-1 px-2 d-inline-flex align-items-center gap-1"
    style="font-size: 0.72rem; border-radius: 6px; font-weight: 600;" (click)="selectAllFiltered()"
    [disabled]="(vehicleValidation.filteredVehicles$ | async)?.length === 0">
    <i class="material-icons" style="font-size: 14px;">select_all</i> Seleccionar todos los filtrados
  </button>
  <button type="button" class="btn btn-outline-danger btn-sm py-1 px-2 d-inline-flex align-items-center gap-1"
    style="font-size: 0.72rem; border-radius: 6px; font-weight: 600;" (click)="deselectAll()"
    [disabled]="vehicleSelected.length === 0">
    <i class="material-icons" style="font-size: 14px;">deselect</i> Deseleccionar todos
  </button>
</div>

<!-- Listado de Vehículos Disponibles (Cuadrilla/Grid) -->
<div class="vehicle-scroll-container">
  <div class="vehicles-grid">
    <div class="vehicle-pill" *ngFor="let vehicle of vehicleValidation.filteredVehicles$ | async"
      [class.selected]="isVehicleSelected(vehicle)" (click)="toggleVehicleSelection(vehicle)">
      <span class="pill-text" [title]="vehicle.unitCode + ' (' + vehicle.plate + ')'">
        {{ vehicle.unitCode }} ({{ vehicle.plate }})
      </span>
      <i class="material-icons">{{ isVehicleSelected(vehicle) ? 'check_circle' : 'add_circle_outline' }}</i>
    </div>
  </div>

  <ng-template #noVehicles>
    <div class="empty-state-list">
      <i class="material-icons">search_off</i>
      <p>No se encontraron vehículos</p>
      <span class="text-muted mt-1">Ajusta los filtros o sube un archivo/imagen.</span>
    </div>
  </ng-template>
</div>